import { STATUS_WARNING_ICON_HEX } from "@app/status-variant";
import { DateTimeCell } from "./datatable/cells";
import { IconAlertTriangle } from "./icons";
import { tokens } from "./tokens";

export function LastDeployAtDisplay({ at }: { at: string }) {
  return <DateTimeCell date={at} />;
}

export function LastDeployNeverDisplay({
  unknown = false,
}: { unknown: boolean }) {
  // if known to never have been deployed, show it
  // otherwise, show N/A (no deployment found from deleted, other issues)
  return (
    <div className="flex items-center gap-1.5">
      {!unknown && (
        <IconAlertTriangle
          variant="sm"
          color={STATUS_WARNING_ICON_HEX}
          className="shrink-0"
          aria-hidden
        />
      )}
      <span className={tokens.type["table lead text"]}>
        {unknown ? "N/A" : "Never deployed"}
      </span>
    </div>
  );
}
